import script from "./Schedule.vue?vue&type=script&setup=true&lang=ts"
export * from "./Schedule.vue?vue&type=script&setup=true&lang=ts"

import "./Schedule.vue?vue&type=style&index=0&id=78fa50ce&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78fa50ce"]])

export default __exports__